import{createIconInner}from"../Icon/createIconInner";import props from"./props";import svg from"./svg";export const IconInfoCircle=createIconInner(props,svg);
//# sourceMappingURL=IconInfoCircle.js.map